import { useContext } from "react";
import { GenerateDeliveryNotePdfActionContext } from "./GenerateDeliveryNotePdfActionContext";

function usePrepareGenerateDeliveryNotePdf() {
  const { setShowModal, setDeliveryNoteId } = useContext(GenerateDeliveryNotePdfActionContext);
  return (deliveryNoteId: string | number) => {
    setDeliveryNoteId(deliveryNoteId);
    setShowModal(true);
  };
}

export default usePrepareGenerateDeliveryNotePdf;
